module.exports = __webpack_public_path__ + "static/screens.c98fe6d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/screens.png
// module id = 444
// module chunks = 35783957827783